import { useEffect, useRef, useState } from 'react'
import { changeMyPassword, type ApiError } from './api'
import { toast } from './toast'

/**
 * Forced when `me.mustChangePassword` (a fresh account or an admin reset). Can't
 * be dismissed until a new password is set.
 */
export function ChangePassword({ onDone }: { onDone: () => void }) {
  const ref = useRef<HTMLDialogElement>(null)
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [next2, setNext2] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    const d = ref.current
    if (d && !d.open) d.showModal()
  }, [])

  async function submit() {
    setErr('')
    if (next.length < 10) return setErr('Use at least 10 characters.')
    if (next !== next2) return setErr('The two new passwords do not match.')
    setBusy(true)
    try {
      await changeMyPassword(current, next)
      toast('Password changed')
      onDone()
    } catch (e) {
      setErr((e as ApiError).message ?? 'Could not change the password.')
      setBusy(false)
    }
  }

  return (
    <dialog ref={ref} onCancel={(e) => e.preventDefault()}>
      <div className="form">
        <h3>Set a new password</h3>
        <p className="k">Your account is using a temporary password. Choose your own to continue.</p>

        <div className="fld">
          <label htmlFor="cpw0">Current / temporary password</label>
          <input
            id="cpw0"
            type="password"
            autoComplete="current-password"
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
          />
        </div>
        <div className="fld">
          <label htmlFor="cpw1">New password</label>
          <input
            id="cpw1"
            type="password"
            autoComplete="new-password"
            value={next}
            onChange={(e) => setNext(e.target.value)}
          />
        </div>
        <div className="fld">
          <label htmlFor="cpw2">Repeat new password</label>
          <input
            id="cpw2"
            type="password"
            autoComplete="new-password"
            value={next2}
            onChange={(e) => setNext2(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && submit()}
          />
        </div>

        {err && <p className="req">{err}</p>}

        <div className="row">
          <button type="button" className="btn p" disabled={busy} onClick={submit}>
            {busy ? 'Working…' : 'Change password'}
          </button>
        </div>
      </div>
    </dialog>
  )
}
